<template>
  <div class="about_container">
    <js-banner
      title="关于甲申"
    />
    <div class="about_wrapper">
      <js-group
        zh="关于甲申"
        en="About Us"
        :list="group"
      />
      <router-view class="content_container"/>
    </div>
  </div>
</template>

<script>
import JsBanner from '@/packages/JsBanner'
import JsGroup from '@/packages/JsGroup'
export default {
  name: 'about',
  components: {
    JsBanner,
    JsGroup
  },
  data () {
    return {
      group: [{
        id: Math.random().toString(),
        label: '公司简介',
        path: '/about/profile'
      }, {
        id: Math.random().toString(),
        label: '企业文化',
        path: '/about/culture'
      }, {
        id: Math.random().toString(),
        label: '企业资质',
        path: '/about/license'
      }, {
        id: Math.random().toString(),
        label: '经营范围',
        path: '/about/scope'
      }, {
        id: Math.random().toString(),
        label: '服务网点',
        path: '/about/branch'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.about_wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 15px 0;
  .content_container {
    flex: 1;
    margin-left: 30px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
}
</style>
